<template>
  <div class="contact-us full-screen">
    <div class="wrapper wrapper-full-page section content dark-background">
      <div class="container auth-container">
        <div class="row">
          <div class="col-md-4 offset-md-4 text-center">
            <div class="logo">
              <router-link to="/" class="simple-text login-logo">
                <img class="img-fluid" src="@/assets/img/ziperase_logo_Light.png" alt="Ziperase Logo">
              </router-link>
            </div>
            <!-- page view here -->
            <slot></slot>
          </div>
        </div>
      </div>
      <content-footer :showEula="false" />
    </div>
  </div>
</template>

<script>
import ContentFooter from "./dashboard/ContentFooter.vue";

export default {
  components: {
    ContentFooter
  }
};
</script>

<style lang="scss" scoped>
.login-logo img {
  max-height: 80px;
  margin-top: 100px;
  margin-bottom: 50px;
}

.auth-container {
  min-height: calc(100vh - 70px);
}
</style>
